import { render, staticRenderFns } from "./BKLoader.vue?vue&type=template&id=2dbc66a6&scoped=true"
import script from "./BKLoader.vue?vue&type=script&lang=js"
export * from "./BKLoader.vue?vue&type=script&lang=js"
import style0 from "./BKLoader.vue?vue&type=style&index=0&id=2dbc66a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc66a6",
  null
  
)

export default component.exports